var paragraph_default = {
  "fontElementMap": "A2cAD",
  "elementSpacing": "fADbn",
  "text": "XlB7j fADbn",
  "child": "Ps-xc"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
